module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-reveal-driver-flag"
  }, [_c('ModalReveal', [_c('button', {
    staticClass: "button danger",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Add flag")]), _c('array-edit', {
    attrs: {
      "options": _vm.extras,
      "values": _vm.body.flags
    }
  }), _c('ActionButton', {
    attrs: {
      "slot": "footer",
      "action": _vm.add,
      "disabled": Object.keys(_vm.body.flags).length === 0
    },
    slot: "footer"
  }, [_vm._v("Add")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a87aa88!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/reveal/AddDriverFlagReveal.vue
// module id = 2361
// module chunks = 1